<template>
  <div>
    <div class="gl_title_bar marginBottom10">
      <div class="gl_tb_left">
        <span class="normaltitle">个人中心</span>
      </div>
    </div>
    <div class="display_between marginTop20">
      <div class="tipBlock display_center_ud" @click="toinfo('userMyMeeting')">
        <div class="imgBlock display_center">
          <img src="/image/geren/imgbg1.png" class="bgimg" />
          <img src="/image/geren/imgtop1.png" />
        </div>
        <div class="marginLeft20">
          <p class="fontsize18 fontBold">全部会议</p>
          <p class="fontsize12 grayColor">All meetings</p>
        </div>
      </div>
      <div class="tipBlock display_center_ud" @click="toinfo('userExchange')">
        <div class="imgBlock display_center">
          <img src="/image/geren/imgbg2.png" class="bgimg" />
          <img src="/image/geren/dh.png" />
        </div>
        <div class="marginLeft20">
          <p class="fontsize18 fontBold">兑换</p>
          <p class="fontsize12 grayColor">Exchange</p>
        </div>
      </div>
      <div class="tipBlock display_center_ud" @click="toinfo('userMyInforShow')">
        <div class="imgBlock display_center">
          <img src="/image/geren/imgbg3.png" class="bgimg" />
          <img src="/image/geren/imgtop2.png" style=" width:23px;height:28px" />
        </div>
        <div class="marginLeft20">
          <p class="fontsize18 fontBold">个人资料</p>
          <p class="fontsize12 grayColor">User data</p>
        </div>
      </div>
      <div class="tipBlock display_center_ud" @click="toinfo('userMyInvoice')">
        <div class="imgBlock display_center">
          <img src="/image/geren/imgbg4.png" class="bgimg" />
          <img src="/image/geren/imgtop3.png" />
        </div>
        <div class="marginLeft20">
          <p class="fontsize18 fontBold">索取发票</p>
          <p class="fontsize12 grayColor">invoice</p>
        </div>
      </div>
    </div>
    <div class="display_between marginTop20">
      <div class="tipBlock display_center_ud" @click="toinfo('userMyCourse')">
        <div class="imgBlock display_center">
          <img src="/image/geren/imgbg5.png" class="bgimg" />
          <img src="/image/geren/imgtop4.png" />
        </div>
        <div class="marginLeft20">
          <p class="fontsize18 fontBold">课程中心</p>
          <p class="fontsize12 grayColor">Course Center</p>
        </div>
      </div>
      <div class="tipBlock display_center_ud" @click="toinfo('userMyCollection')">
        <div class="imgBlock display_center">
          <img src="/image/geren/imgbg6.png" class="bgimg" />
          <img src="/image/geren/imgtop5.png" />
        </div>
        <div class="marginLeft20">
          <p class="fontsize18 fontBold">课程收藏</p>
          <p class="fontsize12 grayColor">Favorites</p>
        </div>
      </div>
      <div class="tipBlock display_center_ud" @click="toinfo('userorgCourse')">
        <div class="imgBlock display_center">
          <img src="/image/geren/imgbg7.png" class="bgimg" />
          <img src="/image/geren/jgkecheng.png" />
        </div>
        <div class="marginLeft20">
          <p class="fontsize18 fontBold">机构课程</p>
          <p class="fontsize12 grayColor">Institutional courses</p>
        </div>
      </div>
      <div class="tipBlock display_center_ud" @click="toinfo('userMyOrder')">
        <div class="imgBlock display_center">
          <img src="/image/geren/imgbg8.png" class="bgimg" />
          <img src="/image/geren/imgtop7.png" />
        </div>
        <div class="marginLeft20">
          <p class="fontsize18 fontBold">课程订单</p>
          <p class="fontsize12 grayColor">Course order</p>
        </div>
      </div>
    </div>
    <div class="gl_title_bar marginTop50">
      <div class="gl_tb_left">
        <span class="normaltitle">我的消息</span>
      </div>
      <div class="gl_tb_right" @click="toMoreMsg('userMymsg')">
        <a href="javascript:;" class="gl_tb_right_more"><img src="/image/index/moreimg.png"
            class="gltb_moreimg" />更多</a>
      </div>
    </div>
    <div class="display_between border_bottom_18 marginTop20" v-for="(item, index) in Allmsglist" :key="index"
      @click.stop="singalread(item)">
      <div>
        <div :class="{ gl_ltStyle_dot: item.read == false }">
          {{ item.title }}
        </div>
      </div>
      <div class="grayColor">
        {{ item.messageTime }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'userInfor',
  data() {
    return {
      apiData: '',
      tagIndex: '',
      Allmsglist: []
    };
  },
  methods: {
    getData() {
      var that = this;
      fetch('/data.json')
        .then(res => {
          return res.json();
        })
        .then(data => {
          that.apiData = data.userInfor.data;
        })

    },
    toinfo(url) {
      this.$router.push({
        path: url
      });
      this.tagIndex == url;
    },
    // 获取消息列表
    getAllmsglist() {
      this.httphelper
        .post('/api/MessageApi/GetNewMessagePageList', {
          userId: this.AuthorId,
          mType: -1,
          page: 1,
          limit: 4
        })
        .then(res => {
          this.Allmsglist = res.data.data;
        });
    },
    // 点击单个消息标记已读
    singalread(item) {
      this.httphelper
        .post('/api/MessageApi/UptNewMessageInfo', {
          mId: item.mid,
          userId: this.AuthorId,
          upType: 1
        })
        .then(res => {
          if (res.data.code == 200) {
            this.getAllmsglist(0, -1, 1);
          }
        });
    },
    toMoreMsg(url) {
      this.$router.push({ name: url });
    }
  },
  created() {
    if (localStorage.getItem('ResData')) {
      // 用户id
      this.AuthorId = JSON.parse(localStorage.getItem('ResData')).id;
    }
    // this.getData();
    //获取我的消息
    this.getAllmsglist(0, -1, 1);
  }
};
</script>

<style scoped>
.tipBlock {
  width: 229px;
  height: 89px;
  background: rgba(255, 255, 255, 0);
  box-shadow: 3px 5px 10px 0px rgba(0, 0, 0, 0.06);
  box-sizing: border-box;
  padding-left: 20px;
  cursor: pointer;
}

.imgBlock {
  width: 64px;
  height: 65px;
  position: relative;
}

.bgimg {
  position: absolute;
  top: 0;
  left: 0;
  z-index: -1;
}
</style>
